"use client";

import { c as _c } from "react/compiler-runtime";
import Image, { ImageProps, StaticImageData } from "next/image";
import { useState, useEffect } from "react";
const shimmer = (w: number | string, h: number | string) => `
<svg width="${w}" height="${h}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <defs>
    <linearGradient id="g">
      <stop stop-color="#f6f7f8" offset="20%" />
      <stop stop-color="#edeef1" offset="50%" />
      <stop stop-color="#f6f7f8" offset="70%" />
    </linearGradient>
  </defs>
  <rect width="${w}" height="${h}" fill="#f6f7f8" />
  <rect id="r" width="${w}" height="${h}" fill="url(#g)" />
  <animate xlink:href="#r" attributeName="x" from="-${w}" to="${w}" dur="1s" repeatCount="indefinite"  />
</svg>`;
const toBase64 = (str: string) => typeof window === "undefined" ? Buffer.from(str).toString("base64") : window.btoa(str);
const ImageComponent = t0 => {
  const $ = _c(57);
  let className;
  let fillProp;
  let height;
  let preloadProp;
  let priority;
  let props;
  let t1;
  let t2;
  let t3;
  let unoptimized;
  let width;
  if ($[0] !== t0) {
    ({
      fill: fillProp,
      addPlaceholder: t1,
      width,
      height,
      fallbackSrc: t2,
      className,
      objectFit: t3,
      priority,
      unoptimized,
      preload: preloadProp,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = fillProp;
    $[3] = height;
    $[4] = preloadProp;
    $[5] = priority;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = unoptimized;
    $[11] = width;
  } else {
    className = $[1];
    fillProp = $[2];
    height = $[3];
    preloadProp = $[4];
    priority = $[5];
    props = $[6];
    t1 = $[7];
    t2 = $[8];
    t3 = $[9];
    unoptimized = $[10];
    width = $[11];
  }
  const addPlaceholder = t1 === undefined ? true : t1;
  const fallbackSrc = t2 === undefined ? "" : t2;
  const objectFit = t3 === undefined ? "cover" : t3;
  const isFill = !!(fillProp || (props as Record<string, unknown>).layout === "fill");
  const isPreload = preloadProp === true || priority === true;
  let otherProps;
  let propAlt;
  let propSizes;
  let propSrc;
  let propStyle;
  if ($[12] !== props) {
    ({
      src: propSrc,
      alt: propAlt,
      style: propStyle,
      sizes: propSizes,
      ...otherProps
    } = props);
    $[12] = props;
    $[13] = otherProps;
    $[14] = propAlt;
    $[15] = propSizes;
    $[16] = propSrc;
    $[17] = propStyle;
  } else {
    otherProps = $[13];
    propAlt = $[14];
    propSizes = $[15];
    propSrc = $[16];
    propStyle = $[17];
  }
  const [imgSrc, setImgSrc] = useState(propSrc);
  let t4;
  let t5;
  if ($[18] !== propSrc) {
    t4 = () => {
      setImgSrc(propSrc);
    };
    t5 = [propSrc];
    $[18] = propSrc;
    $[19] = t4;
    $[20] = t5;
  } else {
    t4 = $[19];
    t5 = $[20];
  }
  useEffect(t4, t5);
  let t6;
  if ($[21] !== height || $[22] !== width) {
    t6 = toBase64(shimmer(width || 40, height || 40));
    $[21] = height;
    $[22] = width;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  const blurDataURL = `data:image/svg+xml;base64,${t6}`;
  if (!imgSrc && !fallbackSrc) {
    const t7 = `relative flex flex-col items-center justify-center bg-gradient-to-br from-[#FDFCFB] to-[#F2EFE9] border border-[#E9E5DD] rounded-xl text-center p-4 select-none ${isFill ? "absolute inset-0 w-full h-full" : ""} ${className || ""}`;
    const t8 = isFill ? undefined : width;
    const t9 = isFill ? undefined : height;
    let t10;
    if ($[24] !== propStyle || $[25] !== t8 || $[26] !== t9) {
      t10 = {
        width: t8,
        height: t9,
        ...propStyle
      };
      $[24] = propStyle;
      $[25] = t8;
      $[26] = t9;
      $[27] = t10;
    } else {
      t10 = $[27];
    }
    let t11;
    let t12;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#8a8175" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" className="mb-2 opacity-70"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" /></svg>;
      t12 = <span className="text-[9px] font-bold tracking-[0.2em] text-[#8a8175] uppercase font-urbanist">No Image</span>;
      $[28] = t11;
      $[29] = t12;
    } else {
      t11 = $[28];
      t12 = $[29];
    }
    let t13;
    if ($[30] !== t10 || $[31] !== t7) {
      t13 = <div className={t7} style={t10}>{t11}{t12}</div>;
      $[30] = t10;
      $[31] = t7;
      $[32] = t13;
    } else {
      t13 = $[32];
    }
    return t13;
  }
  const t7 = imgSrc || fallbackSrc;
  const t8 = propAlt || "";
  const t9 = priority || isPreload;
  const t10 = `object-${objectFit} ${className || ""}`;
  let t11;
  if ($[33] !== propStyle) {
    t11 = {
      ...propStyle
    };
    $[33] = propStyle;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  let t12;
  if ($[35] !== addPlaceholder || $[36] !== blurDataURL || $[37] !== isPreload) {
    t12 = addPlaceholder && !isPreload && {
      placeholder: "blur",
      blurDataURL
    };
    $[35] = addPlaceholder;
    $[36] = blurDataURL;
    $[37] = isPreload;
    $[38] = t12;
  } else {
    t12 = $[38];
  }
  let t13;
  if ($[39] !== height || $[40] !== isFill || $[41] !== width) {
    t13 = isFill ? {
      fill: true
    } : {
      width,
      height
    };
    $[39] = height;
    $[40] = isFill;
    $[41] = width;
    $[42] = t13;
  } else {
    t13 = $[42];
  }
  let t14;
  if ($[43] !== fallbackSrc) {
    t14 = () => {
      setImgSrc(fallbackSrc);
    };
    $[43] = fallbackSrc;
    $[44] = t14;
  } else {
    t14 = $[44];
  }
  let t15;
  if ($[45] !== otherProps || $[46] !== propSizes || $[47] !== t10 || $[48] !== t11 || $[49] !== t12 || $[50] !== t13 || $[51] !== t14 || $[52] !== t7 || $[53] !== t8 || $[54] !== t9 || $[55] !== unoptimized) {
    t15 = <Image {...otherProps} src={t7} alt={t8} unoptimized={unoptimized} priority={t9} sizes={propSizes} className={t10} style={t11} {...t12} {...t13} onError={t14} />;
    $[45] = otherProps;
    $[46] = propSizes;
    $[47] = t10;
    $[48] = t11;
    $[49] = t12;
    $[50] = t13;
    $[51] = t14;
    $[52] = t7;
    $[53] = t8;
    $[54] = t9;
    $[55] = unoptimized;
    $[56] = t15;
  } else {
    t15 = $[56];
  }
  return t15;
};
export default ImageComponent;